const { he } = require("date-fns/locale");

jQuery(document).ready(function ($) {
  /**
   * Checking the subdomain and redirecting to portal.globalsisters.org
   * if the subdomain does not equal "portal".
   */
  function clientRedirect() {
    // Get the current URL
    var currentURL = window.location.href;

    // Define the new subdomain
    var newSubdomain = "portal";

    // Check if the host includes "globalsisters.org"
    if (window.location.host.includes("globalsisters.org")) {
      // Extract the current subdomain
      var subdomainRegex =
        /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.globalsisters\.org/;
      var match = currentURL.match(subdomainRegex);
      var currentSubdomain = match ? match[2] : null;

      // Check if the current subdomain is not equal to "portal"
      if (currentSubdomain !== newSubdomain && currentSubdomain !== null) {
        // Replace the subdomain
        var newURL = currentURL.replace(
          subdomainRegex,
          "$1" + newSubdomain + ".globalsisters.org"
        );

        // Redirect to the new URL
        window.location.href = newURL;
      }
    }
  }

  clientRedirect();

  /**
   * Fix the groups (i.e. community) navigation bar when scrolling
   */
    const groupTypesNav = document.querySelector('nav.groups-type-navs');
    if ( groupTypesNav !== null ) {
      function groupsNavOnScroll() {
        const scrollPosition = window.scrollY;
        const siteHeader = document.querySelector('header.site-header');
        const mainContent = document.getElementById('main');
        const headerBottom = siteHeader.offsetTop + siteHeader.offsetHeight;
        const mainBottom = mainContent.offsetTop + mainContent.offsetHeight;
        const groupsNavTop = groupTypesNav.getBoundingClientRect().top;

        if (scrollPosition > groupsNavTop && scrollPosition < mainBottom) {
          groupTypesNav.classList.add('groups-fixed');
          groupTypesNav.setAttribute('style', 'top: ' + headerBottom + 'px;');
        } else {
          groupTypesNav.classList.remove('groups-fixed');
        }
      }
      window.addEventListener('scroll', groupsNavOnScroll);
    }


  /**
   * Redirect to courses page if a change to a select menu filter reverts all filter inputs to empty
   */
  function assertRedirectToCourses() {
    if (
      $("#bs_members_search").val() == "" &&
      $("#course-topic option:selected").val() == "" &&
      $("#course-industry option:selected").val() == "" &&
      $("#course-business-stage option:selected").val() == ""
    ) {
      return true;
    }
    return false;
  }

  /**
   * Auto-submit form on change of course topic select menu
   */
  $("#course-topic").on("change", function (e) {
    if (assertRedirectToCourses()) {
      e.stopImmediatePropagation();
      window.location = "/courses/";
    } else {
      $("#gs-courses-directory-form").submit();
    }
  });

  /**
   * Auto-submit form on change of course industry select menu
   */
  $("#course-industry").on("change", function (e) {
    if (assertRedirectToCourses()) {
      e.stopImmediatePropagation();
      window.location = "/courses/";
    } else {
      $("#gs-courses-directory-form").submit();
    }
  });

  /**
   * Auto-submit form on change of course business stage select menu
   */
  $("#course-business-stage").on("change", function (e) {
    if (assertRedirectToCourses()) {
      e.stopImmediatePropagation();
      window.location = "/courses/";
    } else {
      $("#gs-courses-directory-form").submit();
    }
  });

  /**
   * Show/Hide the contents tabs in the course details and course materials tabs feature
   */
  $(".gs-course-details-tab-title").click(function () {
    var tabId = $(this).attr("data-tab");

    // Remove active class from all titles and contents
    $(
      ".gs-course-details-tab-title, .gs-course-details-tab-content"
    ).removeClass("active");

    // Add active class to clicked title and its content
    $(this).addClass("active");
    $('.gs-course-details-tab-content[data-content="' + tabId + '"]').addClass(
      "active"
    );
  });

  /**
   * Redirect to blogs page if a change to a select menu filter reverts all filter inputs to empty
   */
  function assertBlogRedirectToCourses() {
    if (
      $("#bs_blog_search").val() == "" &&
      $("#blog-industry option:selected").val() == "" &&
      $("#blog-business-stage option:selected").val() == ""
    ) {
      return true;
    }
    return false;
  }

  /**
   * Auto-submit form on change of blog industry select menu
   */
  $("#blog-industry").on("change", function (e) {
    if (assertBlogRedirectToCourses()) {
      e.stopImmediatePropagation();
      window.location = "/resources/";
    } else {
      $("#gs-blog-form").submit();
    }
  });

  /**
   * Auto-submit form on change of blog business stage select menu
   */
  $("#blog-business-stage").on("change", function (e) {
    if (assertBlogRedirectToCourses()) {
      e.stopImmediatePropagation();
      window.location = "/resources/";
    } else {
      $("#gs-blog-form").submit();
    }
  });

  // Hide the ld-content-actions divs if they are empty. Horrible hack
  $(".ld-tabs-content .gs-course-steps .ld-content-actions").each(function () {
    if ($.trim($(this).html()) === "") {
      $(this).hide();
    }
  });

  $("#cancelBookingBtn").on("click", function () {
    var courseId = $(this).data("course-id");
    var nonce = $(this).data("nonce");
    var courseName = $(this).data("course-name");
    var labelType = $(this).data("label-type");

    if (
      confirm(
        "Are you sure you wish to cancel your " +
          labelType +
          " for " +
          courseName +
          "?"
      )
    ) {
      // If user clicks OK, redirect to the cancel URL
      window.location.href = "?unenroll=" + courseId + "&nonce=" + nonce;
    } else {
      // If user clicks Cancel, do nothing or perform any other action
    }
  });

  // Validate Date of birth so its atleast 18 years from today
  if ($("#field-date-of-birth").length) {
    var maxDob = new Date();
    maxDob.setFullYear(maxDob.getFullYear() - 18);
    $("#field-date-of-birth").datepicker({
      maxDate: maxDob,
      dateFormat: "dd/mm/yy",
      changeMonth: true,
      changeYear: true,
      yearRange: "-90:-18",
    });
  }

  $("#field-phone-number").on("change", function () {
    var phoneNumber = $(this).val();
    // Check if the phone number starts with a plus sign
    var startsWithPlus = phoneNumber.startsWith('+');
    // Remove any non-digit characters; if it starts with a plus, retain it
    var cleanedPhoneNumber = phoneNumber.replace(/[^\d]/g, "");
    // Prepend the plus sign if the original phone number started with it
    if (startsWithPlus) {
      cleanedPhoneNumber = '+' + cleanedPhoneNumber;
    }
    // Ensure the length is between 8 and 15 characters
    if (cleanedPhoneNumber.length > 15) {
      cleanedPhoneNumber = cleanedPhoneNumber.substring(0, 15);
    }

    // Update the input value
    $(this).val(cleanedPhoneNumber);
  });

  // Calculate the number of course items and my course items
  const totalNumberOfCourses = parseInt($('#totalNumberOfCourses').text());
  if ($("#totalCourseItems")) {
    $("#totalCourseItems").text(totalNumberOfCourses);
  }

  // Rename the text "Join Meeting in Browser" to "Join Program" in the zoom meeting countdown box
  const join_zoom_meeting_buttons = $(
    "#zoom_meeting_container .meeting-actions .join-meeting-in-browser"
  );
  if (join_zoom_meeting_buttons.length > 0) {
    join_zoom_meeting_buttons.text("Join Program");
  }


  // Function to process the request membership buttons
  function processRequestMembershipButtons() {
    $('#groups-list .request-membership').each(function () {
      const groupUrl = $(this).attr('data-bp-nonce');
      let url = new URL(groupUrl);
      url.searchParams.delete('_wpnonce');
      let cleanedUrl = url.href;
      $(this).attr('href', cleanedUrl);
      $(this).removeAttr('data-bp-nonce');
      $(this).removeAttr('data-bp-btn-action');
    });
  }

  // Mutation observer callback to process the request membership buttons
  const observerCallback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        processRequestMembershipButtons();
      }
    }
  };
  // Create a mutation observer instance
  const observer = new MutationObserver(observerCallback);

  // Start observing the target node for configured mutations
  const targetNode = document.getElementById('groups-dir-list');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }

  // Call the function initially in case the elements are already present
  processRequestMembershipButtons();

  // Redirect to the group page when the request membership button is clicked
  $(document).on('click', '#groups-list .request-membership', function(e) {
    const groupUrl = $(this).attr('href');
    window.location.href = groupUrl;
  });

  $('#item-header-content .request-membership').each(function() {
    $(this).css('display', 'none');
  });

});
